import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { messages as resources } from './messages';

const MULTI_LANGUAGE_ENABLED = true;

const opts = MULTI_LANGUAGE_ENABLED ? {} : { lng: 'en-GB' };

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en-GB',
    interpolation: {
      escapeValue: false,
    },
    debug: true,
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    ...opts,
  });

export default i18n;
